import { render, staticRenderFns } from "./skillsTab.vue?vue&type=template&id=2c022aa4&scoped=true&"
import script from "./skillsTab.vue?vue&type=script&lang=js&"
export * from "./skillsTab.vue?vue&type=script&lang=js&"
import style0 from "./skillsTab.vue?vue&type=style&index=0&id=2c022aa4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c022aa4",
  null
  
)

export default component.exports